<!-- <div *ngIf="showdashboardpage==false">
    <div class="row mb-2">
        <div class="col ps-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;You are
                            not allowed to view
                            Dashboard</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="global.globalAgencyId != null && global.globalAgencyId != '' && global.globalAgencyId != undefined && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'">
<div class="row text-end">
    <div class="col ps-0">
        <button class="btn blue-btn btn-sm me-2" *ngIf="!expandorCollapseall" (click)="ExpandAll()">
            Expand All
        </button>
        <button class="btn blue-btn btn-sm me-2" *ngIf="expandorCollapseall" (click)="CollapesAll()">
            Collapse All
        </button>
    </div>
</div>

     <!-- Authorization Chart -->
    <!-- <div class="row mt-4">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt" style=" color: #00786a;">Authorization Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL">
                    <div class="row ms-2 w-25">
                        <div class="d-flex align-items-center"> -->
                            <!-- First Radio Button -->
                            <!-- <label class="form-check-label me-3">
                                <input type="radio" value="CURRENTDATE" [(ngModel)]="DashboardChartFilterType" name="AllValues"
                                       (ngModelChange)="getAuthCount()" (click)="filters.clientstatus = 'Expired SA'" class="form-check-input">
                                Current Date
                            </label> -->
                            <!-- Second Radio Button -->
                            <!-- <label class="form-check-label">
                                <input type="radio" value="LASTVISITDATE" [(ngModel)]="DashboardChartFilterType" name="AllValues"
                                       (ngModelChange)="getAuthCount()" (click)="filters.clientstatus = 'Expired SA'" class="form-check-input">
                                Last Service Date
                            </label>
                        </div>
                    </div>
                    
                    <div class="w-100 h-300p">
                        <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="single"
                            [gradient]="gradient" (select)="onSelectExp($event)">
                        </ngx-charts-advanced-pie-chart>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
       <!-- Exceed Auth Chart Dashboard -->
       <!-- <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt" style=" color: #00786a;">Authorization Exceed Line Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expandExceed();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOLEXCEED" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expandExceed();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOLEXCEED" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                    <div class="row ms-2 mt-4" *ngIf="!CollapseBo.EXPBOOLEXCEED">
                        <div class="d-flex">
                            <input type="radio" value="EXCEEDCURRENTDATE" [(ngModel)]="ExceedChartDateType" name="ExceedChartValues" (ngModelChange)="getExceedDateType()" 
                            >&nbsp;<span (click)="ExceedDateType('EXCEEDCURRENTDATE')">Current Date</span> &nbsp;
                        </div>
                        <div class="d-flex ms-2">
                            <input type="radio" value="EXCEEDLASTVISITDATE" [(ngModel)]="ExceedChartDateType" name="ExceedChartValues"
                            (ngModelChange)="getExceedDateType()">&nbsp;<span (click)="ExceedDateType('EXCEEDLASTVISITDATE')">Last Service Date</span> &nbsp;
                        </div>
                    </div>
                
                </div>
                <div class="card-body widget-body setheight" *ngIf="!CollapseBo.EXPBOOLEXCEED">
                    <div class="w-100 ht-100" >
                        <ng-container  *ngIf="openexceedchart== true">
                            <div style="width: 100%;height:100%" #exceedReportContainer></div>
                          </ng-container>
                       
                    </div>
                </div>
            </div>
        </div>
       </div>  -->
    <!-- Housing Stabilization Chart & Employee Exceeding Monthly Hours -->
    <!-- <div class="row">
        <div class="col-lg-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt" style=" color: #00786a;">Housing & Dashboard Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expandHousingorDashboardHours();checkExpandorNot()"
                            *ngIf="CollapseBo.viewHousingorHoursChart" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expandHousingorDashboardHours();checkExpandorNot()"
                            *ngIf="!CollapseBo.viewHousingorHoursChart" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>

                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.viewHousingorHoursChart">
                    <div class="w-100 ">
                        <div class="row">
                            <div class="col-lg-6">
                                <h5 class="mb-0 headertxt" style=" color: #00786a;"> House Stabilization Chart</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                    [results]="HouseStabilizationChart" [gradient]="gradient"
                                    (select)="onSelectHousingStabilization($event)">
                                </ngx-charts-advanced-pie-chart>
                            </div>
                            <div class="col-lg-6" *ngIf="!viewHoursChartList">
                                <h5 class="mb-0 headertxt" style=" color: #00786a;">Employee Exceeding Monthly Hours
                                </h5>
                                <div style="color: red; text-align:center" class="mt-4">
                                    <p>No data available</p>
                                </div>


                            </div>
                            <div class="col-lg-6" *ngIf="viewHoursChartList">
                                <h5 class="mb-0 headertxt" style=" color: #00786a;">Employee Exceeding Monthly Hours
                                </h5>


                                <ngx-charts-pie-chart [results]="DashboardHoursChart" [legend]="true" [legendTitle]="''"
                                    [scheme]="ExceededcolorScheme" [labels]="true" (select)="getHoursList($event)">
                                </ngx-charts-pie-chart>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div> -->


    <div class="row mt-4">
        <div class="col-12 mb-2">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt" style=" color: #00786a;">Referral Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand5();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL5" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand5();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL5" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL5">
                    <div class="row ms-2 w-25">
                        <div class="d-flex align-items-center">
                            <!-- First Radio Button -->
                            <label class="form-check-label me-3">
                                <input type="radio" value="false"  name="AllValues"  [(ngModel)]="referralAge"
                                       (ngModelChange)="getclientcount()" (click)="referralAge = 'false';referralStartdate='';referralEnddate='';" >
                                       Below 24 hrs
                            </label>
                            <!-- Second Radio Button -->
                            <label class="form-check-label">
                                <input type="radio" value="true"  name="AllValues"  [(ngModel)]="referralAge"
                                        (click)="referralAge = 'true'" >
                                       Over 24 hrs
                            </label>
                        </div>
                    </div>
                    <div class="row mt-2 ms-2">
                        <div class="col-12">
                            <div class="row mt-2">
                                <div class="col-lg-2">
                                    <div class="col-lg-12">
                                        <label style="font-weight:bold">From <sup
                                                class="super-script">*</sup></label>
                                    </div>
                                    <div class="col-lg-12">
                                        <my-date-picker [options]="claimsOptions" [selDate]="referralStartdate"
                                            placeholder="mm/dd/yyyy"   [disabled]="referralAge=='false'"                                         
                                            (inputFieldChanged)="DateAuthChanges($event,'inputchanged','referralStartDate')"
                                            (dateChanged)="DateAuthChanges($event,'datechanged','referralStartDate')">
                                        </my-date-picker>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="col-lg-12">
                                        <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
                                    </div>
                                    <div class="col-lg-12">
                                        <my-date-picker [options]="claimsOptions" [selDate]="referralEnddate"
                                            [disabled]="referralStartdate==null || referralStartdate==undefined ||
                                            referralStartdate==''||referralAge=='false' " placeholder="mm/dd/yyyy"
                                            (inputFieldChanged)="DateAuthChanges($event,'inputchanged','referralEndDate')"
                                            (dateChanged)="DateAuthChanges($event,'datechanged','referralEndDate')">
                                        </my-date-picker>
                                    </div>
                                </div>
                                <!-- Apply Button -->
                                <div class="col-lg-4" >
                                    <div class="col-lg-12">
                                        <label style="font-weight:bold"> </label>
                                    </div>
                                    <div class="col-lg-12">
                                        <button class="btn blue-btn me-2 mb-3"  [disabled]="referralStartdate==null || referralStartdate==undefined ||
                                        referralStartdate=='' ||
                                        referralEnddate==null || referralEnddate==undefined ||referralAge=='false'||
                                        referralEnddate==''"  (click)="getclientcount()">Apply
                                            </button>
                                           
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="w-100 h-300p">
                        <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="referral"
                            [gradient]="gradient" (select)="referralExport($event)" >
                        </ngx-charts-advanced-pie-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Coming Due Authorization Chart -->
    <div class="row mt-4">
        <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt" style=" color: #00786a;">Coming Due Authorization Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand2();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL2" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand2();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL2" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL2">
                    <div class="w-100 h-300p">
                        <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="auth"
                            [gradient]="gradient" (select)="onSelect($event)">
                        </ngx-charts-advanced-pie-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Client Zipcode Count Report &  Coming Due Authorization Report   -->
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row">
                        <div class="col-lg-5">
                            <h5 class="mb-0 headertxt" style=" color: #00786a;">Coming
                                Due Authorization Report </h5>
                        </div>
                        <div class="col-lg-6">
                            <h5 class="mb-0 headertxt" style=" color: #00786a;"> Client count per Zipcode </h5>
                        </div>
                    </div>


                    <div class="widget-controls">
                        <a (click)="expandClientZipCodeHours();checkExpandorNot()"
                            *ngIf="CollapseBo.ClientcountperZipcodeList" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expandClientZipCodeHours();checkExpandorNot()"
                            *ngIf="!CollapseBo.ClientcountperZipcodeList" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>

                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.ClientcountperZipcodeList">
                    <div class="w-100 ">
                        <div class="row">
                            <div class="col-lg-5">
                                <!-- <h5 class="mb-0 headertxt" style=" color: #00786a;">Coming Due Authorization Report
                                </h5> -->
                                <div class="row ms-4 mt-4">
                                    <div class="col-lg-4 ps-3 pr-0">
                                        <span>Start date<sup class="super-script">*</sup></span>
                                    </div>
                                    <div class="col-lg-6  ps-0 pr-0">
                                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                            [selDate]="AuthStartDate"
                                            (inputFieldChanged)="DateAuthChanges($event,'inputchanged','FromDate')"
                                            (dateChanged)="DateAuthChanges($event,'datechanged','FromDate')">
                                        </my-date-picker>
                                    </div>
                                </div>
                                <div class="row ms-4 mt-4">
                                    <div class="col-lg-4 ps-3 pr-0">
                                        <span>End date<sup class="super-script">*</sup></span>
                                    </div>
                                    <div class="col-lg-6 ps-0 pr-0">
                                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                            [disabled]="AuthStartDate==null||
                                    AuthStartDate==undefined|| AuthStartDate==''" [selDate]="AuthEndDate"
                                            (inputFieldChanged)="DateAuthChanges($event,'inputchanged','EndDate')"
                                            (dateChanged)="DateAuthChanges($event,'datechanged','EndDate')">
                                        </my-date-picker>

                                    </div>
                                </div>
                                <div class="row ms-4 mt-3">
                                    <div class="col-12 text-center">
                                        <button class="btn blue-btn btn-sm" type="button" [disabled]="AuthStartDate==null||
                                    AuthStartDate==undefined|| AuthStartDate==''||
                                    AuthEndDate==null||
                                    AuthEndDate==undefined ||AuthEndDate=='' "
                                            (click)="getExpiringAuthorizationList();checkComingDueReport =true"
                                            data-bs-toggle="modal" data-bs-target="#viewComingDueAuth">Generate
                                            Report</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7">
                                <!-- <h5 class="mb-0 headertxt" style=" color: #00786a;"> Client count per Zipcode</h5> -->
                                <div type="button" class="btn blue-btn btn-sm "
                                    (click)="downloadClientzipcodeCountExcel()">
                                    Export</div>
                                <ejs-grid #gridClientZipCode [dataSource]='ClientZipCodeList |async'
                                    [allowSorting]='true' [allowResizing]='true' [allowPaging]='true'
                                    [allowFiltering]='true' (dataStateChange)='dataStateClientZipCode($event)'
                                    (actionBegin)="onActionClientZipCode($event)" [pageSettings]='initialPageforZipCode'
                                    [filterSettings]='filterOptions'>
                                    <e-columns>
                                        <!-- 1 -->
                                        <e-column width=100 field='clientcount' [allowFiltering]='false'
                                            [allowSorting]='false' headerText='Count' textAlign='center' type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <!-- 2 -->

                                        <e-column width=200 field='zipcode' [allowFiltering]='true'
                                            [allowSorting]='true' headerText='Zip Code' textAlign='center'
                                            type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>



                                    </e-columns>
                                </ejs-grid>
                                <div *ngIf="ClientZipCodeData.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Claim Chart -->
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted d-flex align-items-center justify-content-between">
                    <h5 class="mb-0 headertxt" style="color: #00786a;">Claim Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand3();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL3" class="transition"><i class="fa fa-chevron-down"></i></a>
                        <a (click)="expand3();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL3" class="transition"><i class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL3">
                    <!-- Count -->
                    <div class="w-100">
                        <div class="row mt-2">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-2">
                                        <div class="col-lg-12">
                                            <label style="font-weight:bold">From <sup
                                                    class="super-script">*</sup></label>
                                        </div>
                                        <div class="col-lg-12">
                                            <my-date-picker [options]="claimsOptions" [selDate]="claimsChartStartDate"
                                                placeholder="mm/dd/yyyy"
                                                [disabled]="is30DaysOlderClaimChart"
                                                (inputFieldChanged)="DateAuthChanges($event,'inputchanged','claimsChartStartDate')"
                                                (dateChanged)="DateAuthChanges($event,'datechanged','claimsChartStartDate')">
                                            </my-date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="col-lg-12">
                                            <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
                                        </div>
                                        <div class="col-lg-12">
                                            <my-date-picker [options]="claimsOptions" [selDate]="claimsChartEndDate"
                                            
                                                [disabled]="claimsChartStartDate==null || claimsChartStartDate==undefined ||
                                        claimsChartStartDate=='' || is30DaysOlderClaimChart " placeholder="mm/dd/yyyy"
                                                (inputFieldChanged)="DateAuthChanges($event,'inputchanged','claimsChartEndDate')"
                                                (dateChanged)="DateAuthChanges($event,'datechanged','claimsChartEndDate')">
                                            </my-date-picker>
                                        </div>
                                    </div>
                                    <!-- Apply Button -->
                                    <div class="col-lg-4" >
                                        <div class="col-lg-12">
                                            <label style="font-weight:bold"> </label>
                                        </div>
                                        <div class="col-lg-12">
                                            <button  *ngIf="!is30DaysOlderClaimChart" class="btn blue-btn me-2 mb-3" [disabled]="claimsChartStartDate==null || claimsChartStartDate==undefined ||
                                            claimsChartStartDate=='' ||
                                            claimsChartEndDate==null || claimsChartEndDate==undefined ||
                                            claimsChartEndDate==''" (click)="claimsChartFilter()">Apply
                                                </button>
                                                <label class="toggle-control">
                                                    <input type="checkbox" [(ngModel)]="is30DaysOlderClaimChart" (ngModelChange)="switchchangeClaimChart()"
                                                    id="toggle30DaysOlderClaimChart"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <label class="font-header ms-2  me-2" style="font-size: 16px;">30 days older</label>
                                                    <span class="control "></span>
                                                </label>
                                        </div>
                                    </div>
                                    <!-- From or Prepared Date -->
                                    <div class="col-lg-4">
                                        <div class="col-lg-12">
                                            <label style="font-weight:bold"> </label>
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="font-header ms-2  me-2" style="font-size: 16px;">From Date</label>
                                            <label class="toggle-control">
                                                <input type="checkbox" [(ngModel)]="isFromorPreparedDateClaimChart" (ngModelChange)="switchchangeforFromorPrepareDateClaimChart()"
                                                id="toggleFromorPreparedDateClaimChart"
                                                    [ngModelOptions]="{standalone: true}">
                                                <label class="font-header ms-2  me-2" style="font-size: 16px;">Prepared Date</label>
                                                <span class="control "></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mt-4 mb-2 headertxt" style="color: #00786a;">Claim Count Chart</h5>
                        <div class="row">
                            <!-- Active 837P Claims -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Active 837P Claims</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Active87PClaimcount" [gradient]="gradient" (select)="claimselect($event,'ActiveClaims',false)"></ngx-charts-advanced-pie-chart>
                            </div>
                            <!-- Active 837I Claims -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Active 837I Claims</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Active87IClaimcount" [gradient]="gradient" (select)="claimselect($event,'ActiveClaims',true)"></ngx-charts-advanced-pie-chart>
                            </div>
                        </div>
                        <div class="row" *ngIf="!is30DaysOlderClaimChart">
                            <!-- Archived 837P Claims -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Archived 837P Claims</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Archeive87PClaimcount" [gradient]="gradient" (select)="claimselect($event,'ArchiveClaims',false)"></ngx-charts-advanced-pie-chart>
                            </div>
                            <!-- Archived 837I Claims -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Archived 837I Claims</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Archeive87IClaimcount" [gradient]="gradient" (select)="claimselect($event,'ArchiveClaims',true)"></ngx-charts-advanced-pie-chart>
                            </div>
                        </div>
                        <h5 class="mt-4 mb-2 headertxt" style="color: #00786a;">Claim Amount Chart</h5>
                        <div class="row">
                            <!-- Active 837P Claims Amount -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Active 837P Claims Amount</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Active87PClaimAmount" [gradient]="gradient" (select)="claimselect($event,'ActiveClaims',false)"></ngx-charts-advanced-pie-chart>
                            </div>
                            <!-- Active 837I Claims Amount -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Active 837I Claims Amount</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Active87IClaimAmount" [gradient]="gradient" (select)="claimselect($event,'ActiveClaims',true)"></ngx-charts-advanced-pie-chart>
                            </div>
                        </div>
                        <div class="row" *ngIf="!is30DaysOlderClaimChart">
                            <!-- Archived 837P Claims Amount -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Archived 837P Claims Amount</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Archeive87PClaimAmount" [gradient]="gradient" (select)="claimselect($event,'ArchiveClaims',false)"></ngx-charts-advanced-pie-chart>
                            </div>
                            <!-- Archived 837I Claims Amount -->
                            <div class="col-md-6 mb-3">
                                <h5 class="headertxt" style="color: #00786a;">Archived 837I Claims Amount</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="Archeive87IClaimAmount" [gradient]="gradient" (select)="claimselect($event,'ArchiveClaims',true)"></ngx-charts-advanced-pie-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    


  <!-- Upcoming Events Chart -->
  <div class="row">
    <div class="col-12 mb-4">
        <div widget class="card border-0 box-shadow widget">
            <div class="card-header transparent border-0 text-muted d-flex align-items-center justify-content-between">
                <h5 class="mb-0 headertxt" style="color: #00786a;">Events in next 30 days</h5>
                <div class="widget-controls">
                    <a (click)="expand4();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL4" class="transition"><i class="fa fa-chevron-down"></i></a>
                    <a (click)="expand4();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL4" class="transition"><i class="fa fa-chevron-up"></i></a>
                </div>
            </div>
            <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL4">
                <!-- Count -->
                <div class="w-100">
                    <div class="row mt-2">
                        <div class="col-12">
                            <div class="upcoming-events">
                                <!-- <h3>Events in next 30 days</h3> -->
                                <div class="event-grid">
                                    <div class="event-card" *ngFor="let event of events  | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage,
                                        totalItems: totalCount  }">
    
                                    <h4>{{ event.clientName }}</h4>
                                    <p>{{ event.eventTitle }}</p>
                                    <p><strong>Date:</strong> {{ event.startTime | date: 'fullDate' }}</p>
                                    <p><strong>Time:</strong> {{ event.startTime  | date:'shortTime'}}</p>
                                    <p><strong>Status:</strong> {{ event.statusName  }}</p>
                                    <!-- <p *ngIf="event.location"><strong>Location:</strong> {{ event.location }}</p> -->
                                  </div>
                                </div>
                              </div>

                              <pagination-controls  
                                [totalItems]="totalCount"
                              [itemsPerPage]="itemsPerPage"
                              [(currentPage)]="currentPage"
                              (pageChange)="onPageChange($event)">
                            </pagination-controls>

                        </div>
                    </div>
                  
                   
                </div>
            </div>
        </div>
    </div>
</div>



    
    <!-- Claim Amount Chart -->
    <!-- Pending UMPI Chart  & Employee List-->
    <!-- <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row mb-0">
                        <div class="col-5  headertxt">
                            <h5 style=" color: #00786a;">Pending UMPI Chart</h5>
                        </div>
                        <div class="col-7  headertxt">
                            <h5 style=" color: #00786a;">Employee List</h5>
                        </div>
                    </div>
                    <div class="widget-controls">
                        <a (click)="expand1();checkExpandorNot()" *ngIf="CollapseBo.EXPBOOL1" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand1();checkExpandorNot()" *ngIf="!CollapseBo.EXPBOOL1" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.EXPBOOL1">
                    <div class="row">
                        <div class="col-lg-5 col-md-12 col-sm-12 mychart">
                            <div class="w-100 h-300p">
                                <ngx-charts-pie-grid [scheme]="colorScheme1" [results]="multi"
                                    (select)="onSelect1($event)">
                                </ngx-charts-pie-grid>
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-12 col-sm-12">
                           <div class="row mb-2">
                            <div class="ms-auto me-3">
                                <button type="button" class="btn blue-btn btn-sm butstyle"  data-target="#printalert" data-toggle="modal">
                                    <i class="fa fa-print"> </i>Print
                                  </button>
                                <button type="button" class="btn blue-btn btn-sm butstyle ms-2" 
                                data-toggle="modal" data-target="#exportascsvmodel" >
                                <i class="fa fa-file-excel-o me-1" ></i>Export</button>
                            </div>
                        </div>
                     
                            <div class="control-section">
                                <ejs-grid #grid [dataSource]='data|async' [allowSorting]='true' [allowResizing]='true'
                                    [allowPaging]='true' [allowFiltering]='true'
                                    (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                                    [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                    (click)="gotoempDetails($event)" [showColumnChooser]="true">
                                    <e-columns>
                                        <e-column minWidth=140 field='name' [allowFiltering]="false"
                                            headerText='Employee' textAlign='left' width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='month' headerText='Month' textAlign='left'
                                            width=100 [allowFiltering]="false"> </e-column>
                                        <e-column minWidth=100 field='exceededHours' headerText='Exceeded Hrs'
                                            textAlign='left' width=100 [allowFiltering]="false"> </e-column>
                                        <e-column minWidth=100 field='totalhours' headerText='Total Hrs'
                                            textAlign='left' width=100 [allowFiltering]="false"> </e-column>
                                        <e-column minWidth=100 field='email' headerText='Email' textAlign='left'
                                            width=100 type="string" [allowFiltering]="false">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='phone1' headerText='Phone' textAlign='left'
                                            [allowFiltering]="false" width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>
                                <div *ngIf="empdata.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Excluded Employees -->
    <!-- <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row">
                        <div class="col-lg-8">
                            <h5 class="mb-0 headertxt" style=" color: #00786a;">Excluded Employees</h5>
                        </div>
                        <div type="button" class="btn blue-btn btn-sm ms-3" (click)="openOig()">OIG
                            Analysis</div>
                        <div class="widget-controls">
                            <a (click)="expandExcludedAuth();checkExpandorNot()" *ngIf="CollapseBo.Excludedbool"
                                class="transition"><i class="fa fa-chevron-down"></i></a>
                            <a (click)="expandExcludedAuth();checkExpandorNot()" *ngIf="!CollapseBo.Excludedbool"
                                class="transition"><i class="fa fa-chevron-up"></i></a>
                        </div>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!CollapseBo.Excludedbool">
                    <div class="col">
                        <div class="row mt-3"></div>
                        <div class="control-section">
                            <ejs-grid #gridOig [dataSource]='matchedleie' [allowSorting]='true' [allowResizing]='true'
                                [allowPaging]='true' [allowFiltering]='true'
                                (dataStateChange)='dataStateChangeOIG($event)'
                                (actionBegin)="onActionCompleteOIG($event)" [pageSettings]='initialPage1'
                                [filterSettings]='filterOptions' (resizeStop)="onResize($event)">
                                <e-columns>
                                    <e-column field="name" headerText="Name" type='string' width=140
                                        [allowFiltering]='false'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="dob" headerText="DOB" type='date' [allowFiltering]='false'
                                        [format]='formatOptions' width=100>
                                    </e-column>
                                    <e-column field="age" headerText="Age" [allowFiltering]='false' type='number'>
                                    </e-column>
                                    <e-column field="email" headerText="Email" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="phone1" headerText="Phone" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="phone2" headerText="Phone 2" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="street" headerText="Street" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="zipcode" headerText="ZIP Code" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="statusLidName" headerText="Status" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                            <div *ngIf="ExcludedEmployeesList == 0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>
<!-- openComingDueAuth -->
<span id="openComingDueAuth" data-bs-toggle="modal" data-bs-target="#viewComingDueAuth"></span>
<div class="modal " id="viewComingDueAuth" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-start font-header me-5">Coming Due Auth</h5>
                &nbsp;&nbsp;
                <div class="text-end">
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 text-start">
                        <ng-container>
                            <button type="button" class="btn blue-btn btn-sm butstyle ms-0"
                                (click)="ComingDuePowerBiReports()">
                                <i class="fa fa-print me-2"></i>Print
                            </button>
                        </ng-container>
                    </div>
                   
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <ejs-grid #gridAuthList [dataSource]='dataAuth |async' [allowExcelExport]='true'
                            [allowSorting]='true' [allowPdfExport]='true' [allowResizing]='true' [allowPaging]='true'
                            [allowFiltering]='true' (dataStateChange)='dataStateComingDueChange($event)'
                            (actionBegin)="onActionComingDueComplete($event)" 
                            [pageSettings]='ComingDuePage' [filterSettings]='filterOptions' [showColumnChooser]="true"  height="400">
                            <e-columns>
                                <!-- 1 -->
                                <e-column width=200 field='clientName' headerText='Client Name' [allowFiltering]='true'
                                    textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 2 -->
                                <e-column width=200 field='companyName' [allowFiltering]='true'
                                    headerText='Company Name' textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 3 -->
                                <e-column width=200 field='serviceCode' [allowFiltering]='true'
                                    headerText='Service Code' textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 4 -->
                                <e-column width=100 field='payerName' [allowFiltering]='true' headerText='Payer Name'
                                    textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 5 -->
                                <e-column width=150 field="startDate" headerText="Start Date" type="date"
                                    textAlign='center' [allowFiltering]="false" [format]='formatOptions'>
                                </e-column>
                                <!-- 6 -->
                                <e-column width=150 field="endDate" headerText="End Date" type="date"
                                    [allowFiltering]="false" textAlign='center' [format]='formatOptions'>
                                </e-column>
                                <e-column width=200 field='employeeName' [allowFiltering]='false' headerText='Employee Name'
                                    textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 7 -->
                                <e-column width=150 field="phone" headerText="Phone Number" type="string"
                                    [allowFiltering]='false' textAlign='center'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 8 -->
                                <e-column width=150 field="location" headerText="Location" [allowFiltering]='false'
                                    type="string" textAlign='center'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 9 -->
                                <e-column width=200 field="authorizationNo" [allowFiltering]='false'
                                    headerText="Authorization Number" textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 10 -->
                                <e-column width=200 field="insuranceNo" [allowFiltering]='false'
                                    headerText="Insurance Number" type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 11-->
                                <e-column width=200 field="county" [allowFiltering]='false' headerText="County"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 12 -->
                                <e-column width=200 field="medicare" [allowFiltering]='false' headerText="Medicare"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 13 -->
                                <e-column width=200 field="waiver" [allowFiltering]='false' headerText="Waiver"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 14 -->
                                <e-column width=200 field="street" [allowFiltering]='false' headerText="Street"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 15 -->
                                <e-column width=200 field="zipCode" [allowFiltering]='false' headerText="ZipCode"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 16 -->
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>

                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>

                        <div *ngIf="AuthDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="gridClear()"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="openRemainingunit" data-bs-toggle="modal" data-bs-target="#viewremainigunit"></span>
<div class="modal " id="viewremainigunit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-start font-header me-5">Low Units</h5>
                &nbsp;&nbsp;
                <div class="text-end">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="gridClear();RemainUnit=false;"></button>
                </div>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 text-start">
                        <ng-container>
                            <button type="button" class="btn blue-btn btn-sm butstyle ms-0"
                                (click)="ComingDuePowerBiReports()">
                                <i class="fa fa-print me-2"></i>Print
                            </button>
                        </ng-container>
                    </div>
                   
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <ejs-grid #gridUnitList [dataSource]='dataAuth |async' [allowExcelExport]='true'
                        [allowSorting]='false' [allowPdfExport]='true' [allowResizing]='true' [allowPaging]='true'
                        [allowFiltering]='true' (dataStateChange)='dataStateComingDueChange($event)'
                        (actionBegin)="onActionLowUnits($event)" 
                        [pageSettings]='ComingDuePage' [filterSettings]='filterOptions' [showColumnChooser]="true"
                        height="400">
                            <e-columns>
                                <!-- 1 -->
                                <e-column width=200 field='clientName' headerText='Client Name' [allowFiltering]='false'
                                    textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 2 -->
                                <e-column width=200 field='companyName' [allowFiltering]='false'
                                    headerText='Company Name' textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 3 -->
                                <e-column width=200 field='serviceCode' [allowFiltering]='false'
                                    headerText='Service Code' textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 4 -->
                                <e-column width=100 field='payerName' [allowFiltering]='false' headerText='Payer Name'
                                    textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 5 -->
                                <e-column width=150 field="startDate" headerText="Start Date" type="date"
                                    textAlign='center' [allowFiltering]="false" [format]='formatOptions'>
                                </e-column>
                                <!-- 6 -->
                                <e-column width=150 field="endDate" headerText="End Date" type="date"
                                    [allowFiltering]="false" textAlign='center' [format]='formatOptions'>
                                </e-column>
                                <e-column width=200 field='employeeName' [allowFiltering]='false' headerText='Employee Name'
                                    textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column width=200 field='unitsRemaining' [allowFiltering]='false'
                                    headerText='Remaining Units' textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column width=200 field='totalUnits' [allowFiltering]='false'
                                    headerText='Total Units' textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 7 -->
                                <e-column width=150 field="phone" headerText="Phone Number" type="string"
                                    [allowFiltering]='false' textAlign='center'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 8 -->
                                <e-column width=150 field="location" headerText="Location" [allowFiltering]='false'
                                    type="string" textAlign='center'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 9 -->
                                <e-column width=200 field="authorizationNo" [allowFiltering]='false'
                                    headerText="Authorization Number" textAlign='center' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 10 -->
                                <e-column width=200 field="insuranceNo" [allowFiltering]='false'
                                    headerText="Insurance Number" type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 11-->
                                <e-column width=200 field="county" [allowFiltering]='false' headerText="County"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 12 -->
                                <e-column width=200 field="medicare" [allowFiltering]='false' headerText="Medicare"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 13 -->
                                <e-column width=200 field="waiver" [allowFiltering]='false' headerText="Waiver"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 14 -->
                                <e-column width=200 field="street" [allowFiltering]='false' headerText="Street"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 15 -->
                                <e-column width=200 field="zipCode" [allowFiltering]='false' headerText="ZipCode"
                                    type="string" textAlign='center' width=100>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 16 -->
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>

                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>

                        <div *ngIf="AuthDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="gridClear();RemainUnit=false;"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- openDashboardHours -->
<span id="openDashboardHours" data-bs-toggle="modal" data-bs-target="#showDashboardHours"></span>
<div class="modal " id="showDashboardHours" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-start font-header me-5">Hours Details</h5>
                <button type="button" class="close" (click)="clearHoursGrid()" data-bs-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 text-start">
                        <button type="button" class="btn blue-btn btn-sm butstyle ms-0"
                            (click)="downloadExcelforDashboardHours()">
                            <i class="fa fa-print me-2"></i>Print
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <ejs-grid #gridHoursList [dataSource]='DashboardHoursList |async' [allowExcelExport]='true'
                            [allowSorting]='false' [allowPdfExport]='true' [allowResizing]='true' [allowPaging]='true'
                            [allowFiltering]='true' (dataStateChange)='dataStateHoursChange($event)'
                            (actionBegin)="onActionHoursComplete($event)" [pageSettings]='initialPageHours'
                            [filterSettings]='filterOptions'>
                            <e-columns>
                                <!-- 1 -->
                                <e-column width=200 field='employeeName' headerText='Employee Name'
                                    [allowFiltering]='true' [allowSorting]='true' textAlign='left' type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- 2 -->
                                <e-column width=200 field='projectedHours' [allowSorting]='false'
                                    [allowFiltering]='false' headerText='Projected Hours' textAlign='center'
                                    type="number">
                                </e-column>
                                <!-- 3 -->
                                <e-column width=200 field='average' [allowSorting]='false' [allowFiltering]='false'
                                    headerText='Average' textAlign='center' type="number">
                                </e-column>

                            </e-columns>
                        </ejs-grid>

                        <div *ngIf="HoursData.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="clearHoursGrid()"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<span id="openPowerBiModal" data-bs-toggle="modal" data-bs-target="#viewPowerBiReport"></span>
<div class="modal fade" id="viewPowerBiReport" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{reptitle}}</h5>
                <div class="text-end">
                    <button class="btn blue-btn btn-sm me-2" (click)="closemodal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="reportcontain== true">
                    <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Export as CSV</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    &times;
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="ExportCurrentPageUmpiEmployee()">
                            Print Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="ExportAllPendingUmpiEmployee()">
                            Print All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="printalert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Print confirmation</h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        Do you want to print this record ?
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm butstyle " data-bs-dismiss="modal" (click)="printUMPIEmployee()">Print
        </button>
        <button class="btn blue-btn btn-sm butstyle " data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

